import React from 'react';
import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import BaseComponent from 'components/BaseComponent';
import { symbols } from 'sf/helpers';

export const POSITIONS = symbols('TOP', 'BOTTOM', 'LEFT', 'RIGHT');

export default function withLabel(ComposedComponent) {
  return class Label extends BaseComponent {
    className = 'ts-Label';

    static propTypes = {
      labelClassName: PropTypes.string,
      labelPosition: PropTypes.oneOf(Object.values(POSITIONS)),
      labelText: PropTypes.string,
    };

    static defaultProps = {
      labelClassName: null,
      labelPosition: POSITIONS.TOP,
      labelText: null,
    };

    setValid = (...args) => this.refs.component.setValid(...args);

    render() {
      const { labelClassName, labelPosition, labelText } = this.props;
      const classNames = {
        '--column': labelPosition === POSITIONS.BOTTOM,
        '--reversed': labelPosition === POSITIONS.LEFT,
        '--column-reversed': labelPosition === POSITIONS.TOP,
      };
      const id = `label-${this.componentId}`;

      return (
        <div className={ this.rootcn(classNames) }>
          <ComposedComponent
            { ...omit(this.props, ['labelText']) }
            id={ id }
            ref="component"
          />
          { labelText &&
            <label
              className={ this.cn({
                '__label': true,
                ...classNames,
                [labelClassName]: !!labelClassName,
              }) }
              htmlFor={ id }
            >
              { labelText }
            </label>
          }
        </div>
      );
    }
  };
}
